"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardHeader = void 0;
require("./CardHeader.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * CardHeader component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns CardHeader
 */

const CardHeader = props => {
  const {
    externalMedia,
    headerPadding,
    image
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-CardHeader', {
    ["pal-c-CardHeader__padding--".concat(headerPadding)]: headerPadding
  });
  const displayContent = () => {
    switch (true) {
      case !!externalMedia:
        return (0, _renderObject.renderObject)(externalMedia);
      case !!image:
        return /*#__PURE__*/_react.default.createElement(_Image.default, {
          desktopImage: image === null || image === void 0 ? void 0 : image.desktopImage,
          tabletImage: image === null || image === void 0 ? void 0 : image.tabletImage,
          mobileImage: image === null || image === void 0 ? void 0 : image.mobileImage,
          altText: image === null || image === void 0 ? void 0 : image.altText,
          ratio: image === null || image === void 0 ? void 0 : image.ratio,
          loading: image === null || image === void 0 ? void 0 : image.loading
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardHeader__imageContainer"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, displayContent())));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} externalMedia - url, altText, ratio and loading prop for external image or video
 * @property {object} image - url, altText, ratio and loading prop for Image component
 */
exports.CardHeader = CardHeader;
CardHeader.propTypes = {
  /**
   * Allows header prop to accept an object of external media
   */
  externalMedia: _propTypes.default.object,
  /**
   * Allows header prop to accept an object
   * - **imgAlt:** The alt text for the image
   * - **imgSrc:** The URL for the image
   * - **imgRatio:** The ratio for the image oneOf( ['1x1', '4x5', '5x4', '9x16', '16x9'] ),
   */
  image: _propTypes.default.object
};
var _default = exports.default = CardHeader;